import React from 'react'
import { ProfessionalMain, ProfessionalHeader } from './subcomponents'
import {
  filterSampleEntries,
  nodeLocaleToEnglishLanguage,
  timezone2tzid,
  tabsObject,
} from '@utils'
import moment from 'moment-timezone'
import { useLocale } from '@hooks'

const ProfessionalDetailContent = ({
  professional,
  parentPath,
  englishName,
  englishTitle,
  news,
  events,
  insights,
  newAccolades,
  previousQuery,
  previousRefinements,
}) => {
  const { locale } = useLocale()
  const {
    languages,
    admissions,
    education,
    accolades,
    practiceAreas,
    links,
    overviewHtml,
    bioHtml,
    bioAccoladesHtml,
    bioEducationHtml,
  } = professional

  const overview = [
    { title: 'Overview', html: overviewHtml || bioHtml },
    {
      title: 'Accolades',
      html: bioAccoladesHtml,
    },
    { title: 'Education', html: bioEducationHtml },
  ]

  const filterAssociated = data => {
    return filterSampleEntries(data)?.filter(node =>
      node?.displayOnSites.includes(nodeLocaleToEnglishLanguage[locale])
    )
  }

  const filteredNews = filterAssociated(news)
  const filteredEvents = filterAssociated(events)?.map(item => ({
    ...item,
    currentTimezoneDate:
      item?.eventStart &&
      item?.timeZone &&
      moment.tz(item?.eventStart, timezone2tzid[item?.timeZone]).local(),
  }))

  const filteredInsights = filterAssociated(insights)?.filter(
    ({ category }) => category?.title !== 'Accolades'
  )
  const filteredAccolades = filterAssociated(newAccolades)

  const mappedLinks = links?.map(({ type, ...rest }) => ({
    ...rest,
    type: type?.toLowerCase().includes('linkedin')
      ? 'linkedIn'
      : type?.toLowerCase(),
  }))

  const mappedProfessional = {
    ...professional,
    overviewTab: overview,
    news: filteredNews,
    events: filteredEvents,
    insights: filteredInsights,
    rankings: filteredAccolades,
    links: mappedLinks,
    englishName,
    englishTitle,
  }

  const tabsArr = Object.keys(tabsObject)
  const newTabsArr = tabsArr?.filter(t => {
    return (
      (t === 'overview' && mappedProfessional?.overviewTab?.length > 0) ||
      (Array.isArray(mappedProfessional[t]) &&
        mappedProfessional[t]?.length > 0) ||
      (!Array.isArray(mappedProfessional[t]) && mappedProfessional[t])
    )
  })

  const sidebarInfo = [
    practiceAreas,
    languages,
    admissions,
    education,
    accolades,
  ]

  return (
    <>
      <ProfessionalHeader
        professional={mappedProfessional}
        parentPath={parentPath}
        tabsArr={newTabsArr}
        previousQuery={previousQuery}
        previousRefinements={previousRefinements}
      />
      <ProfessionalMain
        tabsArr={newTabsArr}
        data={mappedProfessional}
        sidebar={sidebarInfo}
      />
    </>
  )
}

ProfessionalDetailContent.propTypes = {}

export default ProfessionalDetailContent
